import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pages.css';

function Impressum({ name, email }) {
  // Default values in case props aren't provided
  const fullName = name || "Julian Streibel";
  const contactEmail = email || "julian@streibel.xyz";
  const navigate = useNavigate();
  
  // Function to handle back button click using history
  const handleBack = () => {
    navigate('/'); // Navigate directly to home
  };
  
  return (
    <div className="legal-page">
      {/* Back button - with no border */}
      <button onClick={handleBack} className="back-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
        Zurück zur Startseite
      </button>
      
      <div className="legal-container">
        <h1>Impressum</h1>
        
        <div className="legal-section">
          <h2>Angaben gemäß § 5 ECG</h2>
          <p>{fullName}</p>
        </div>
        
        <div className="legal-section">
          <h2>Kontakt</h2>
          <p>E-Mail: {contactEmail}</p>
        </div>
        
        <div className="legal-section">
          <h2>Grundlegende Richtung</h2>
          <p>Persönliche Website mit Informationen über meine beruflichen Tätigkeiten und Projekte.</p>
        </div>
        
        <div className="legal-section">
          <h2>Haftungsausschluss</h2>
          <br />
          
          <h3>Haftung für Inhalte</h3>
          <p>Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte kann ich jedoch keine Gewähr übernehmen. Als Diensteanbieter bin ich gemäß § 13 ECG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Gemäß §§ 13-16 ECG bin ich als Diensteanbieter jedoch nicht verpflichtet, die von ihnen übermittelten oder gespeicherten Informationen zu überwachen oder nach Umständen zu forschen, die auf rechtswidrige Tätigkeiten hinweisen.</p>
          
          <h3>Haftung für Links</h3>
          <p>Diese Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werde ich derartige Links umgehend entfernen.</p>
          
          <h3>Urheberrecht</h3>
          <p>Die Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
        </div>
      </div>
    </div>
  );
}

export default Impressum; 